import styled from "@emotion/styled";
import { ButtonBase, Typography } from "@mui/material";
import { CHAT_CONTENT_MAX_WIDTH } from "@features/Chat/chat-helpers";
import { Button } from "@avenue-8/sidekick-ui";

export const Container = styled.div<{ $disabled?: boolean; $embedded?: boolean }>`
  width: 100%;
  ${(p) => !p.$embedded && "grid-area: suggestions;"}
  overflow-y: auto;
  display: grid;
  grid-template-areas: "view";
  align-items: start;
  padding-top: 2rem;
  ${(p) => p.$disabled && "pointer-events: none;"}
`;

export const ViewWrapper = styled.div`
  grid-area: view;
  width: 100%;
  max-width: ${CHAT_CONTENT_MAX_WIDTH};
  margin: 0 auto;
  padding: 0 1rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const ViewHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  max-width: 600px;
`;

export const SidekickLogoImg = styled.img`
  width: 56px;
  height: 56px;
`;

export const HeaderIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.colors.primary};
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;

  svg {
    font-size: 2.5rem;
  }
`;

export const ViewTitle = styled(Typography)`
  color: ${(p) => p.theme.text.colors.brand};
  text-align: center;

  ${(p) => p.theme.media.laptopDown} {
    font-size: ${(p) => p.theme.title.fontSizes.h5};
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 600px;
  background-color: ${(p) => p.theme.colors.background5};
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
`;

export const Row = styled(ButtonBase)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: ${(p) => p.theme.colors.background};
  border-radius: 0.625rem;
  padding: 0.875rem 1rem;
  text-align: left;
  transition: background-color 0.15s ease;
  border: 1px solid transparent;

  &:hover {
    border-color: ${(p) => p.theme.colors.primary};
    background-color: ${(p) => p.theme.colors.background5};
  }
`;

export const RowIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.text.colors.brand};
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;

  svg {
    font-size: 1.5rem;
  }
`;

export const RowLabel = styled(Typography)`
  font-weight: 600;
  font-size: ${(p) => p.theme.text.fontSizes.m};
  color: ${(p) => p.theme.text.colors.primary};
  flex: 1;
`;

export const BackRow = styled(Button)`
  padding: 0;
  color: ${(p) => p.theme.button.outlined.colors.text};
`;
